import thanksARamaGiveAway from './../../images/30k-thanks-a-rama-giveaway.png';
import foxLogosFaq from './../../images/fox-shows-faq.png';

const Info = () => {
    return (
        <div style={{color: "white", fontFamily: "Inter", lineHeight: "125%"}}>
            <div style={{textAlign: "center", paddingTop: "20px", maxWidth: "480px", marginLeft: "auto", marginRight: "auto"}}>
                <img style={{marginBottom: "20px"}} src={thanksARamaGiveAway} alt="Thanks-A-Rama-Give-Away"/>
                <img src={foxLogosFaq} alt="Thanks-A-Rama-Give-Away Three logo shows" style={{width: "100%"}}/>
            </div>            
            <p style={{lineHeight: "125%", paddingLeft: "20px", paddingRight: "20px"}}>Earn a <span style={{color: "#FD5"}}>digital ticket</span> each time you scan a QR code! The more you watch and play, the better chance you’ll have of being one of three lucky winners to take home</p>
            <p style={{
                textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25), 2px 2px 0px #208DD9",
                fontFamily: "Rubik",
                fontSize: "50px",
                marginTop: "0px",
                marginBottom: "0px",
                fontWeight: "800"
            }}>$10,000!</p>        

            <div style={{borderRadius: "20px", marginTop: "30px", paddingTop: "10px", paddingBottom: "30px", paddingRight: "20px", paddingLeft: "20px", background: "rgba(255, 255, 255, 0.15)", width: "80%", marginLeft: "auto", marginRight: "auto"}}>
                <h2 style={{lineHeight: "100%", fontFamily: "Rubik", fontSize: "30px", fontWeight: "700"}}>HOW DO I EARN <br/><span style={{color: "#FD5"}}>DIGITAL TICKETS</span>?</h2>
                <ol style={{lineHeight: "150%", paddingInlineStart: "20px", textAlign: "left", fontSize: "16px"}}>
                    <li style={{marginBottom: "20px"}}>Watch each episode of <b>25 Words or Less</b>, <b>Pictionary</b>, and <b>Person Place or Thing</b></li>
                    <li style={{marginBottom: "20px"}}>Find and <b>scan</b> the QR Code on each episode (there are a few!)</li>
                    <li style={{marginBottom: "20px"}}>Each <b>scan</b> will earn you <span style={{color: "#FD5"}}>1 digital ticket</span> towards the grand prize</li>
                </ol>
                <p style={{fontWeight: "700", marginTop: "30px", lineHeight: "150%"}}>
                    The more tickets you collect, the greater your chances of snagging one of three ultimate grand prizes!
                </p>
                <div style={{fontSize: "12px", fontWeight: "500", marginTop: "30px", opacity: 0.5, paddingLeft: "15px", paddingRight: "15px"}}>    
                    <button onClick={()=>window.open(process.env.REACT_APP_30K_GIVEAWAY_RULES_URL)} style={{background: "none", border: "none", textDecoration: "underline", color: "#fff"}}>See Official Rules for more details</button>
                    <p>$30K Thanks-A-Rama Giveaway Sweepstakes Period  runs September 9, 2024 thru May 30, 2025.</p>
                    <p>You must log in to your account or <span style={{}}>create an account</span> to earn digital tickets. </p>
                </div>
            </div>
        </div>
    )
}

export default Info;